import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'ee-user-form',
  template: `
    <div class="section-wrapper" [formGroup]="form">
      <div class="in-row-grid">
        <mat-form-field class="double-column">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="first_name" required />
          @if (form?.get('first_name').hasError('required')) {
            <mat-error>Please enter your first name.</mat-error>
          }
          <mat-hint>Required</mat-hint>
        </mat-form-field>
        <mat-form-field class="double-column">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="last_name" required />
          @if (form?.get('last_name').hasError('required')) {
            <mat-error>Please enter your last name.</mat-error>
          }
          <mat-hint>Required</mat-hint>
        </mat-form-field>
        <mat-form-field class="double-column">
          <mat-label>Email Address</mat-label>
          <input matInput formControlName="email" required />
          @if (form?.get('email').hasError('required')) {
            <mat-error>Please enter your email address.</mat-error>
          }
          @if (form?.get('email').hasError('email')) {
            <mat-error>Please enter a valid email address.</mat-error>
          }
          @if (form?.get('email').hasError('emailTaken')) {
            <mat-error>Email address is associated with an existing account.</mat-error>
          }
          <mat-hint>Required</mat-hint>
        </mat-form-field>
        <mat-form-field class="double-column">
          <mat-label>Phone Number</mat-label>
          <input matInput mask="(000) 000-0000" formControlName="phone_number" required />
          @if (form?.get('phone_number').hasError('required')) {
            <mat-error>Please enter a phone number.</mat-error>
          }
          <mat-hint>Required</mat-hint>
        </mat-form-field>
      </div>
    </div>
  `,
  standalone: false
})
export class UserDetailsFormComponent {
  @Input({ required: true }) form: UntypedFormGroup;
}
